var _dec, _dec2, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import ModelTraits from "../ModelTraits";
import primitiveTrait from "../Decorators/primitiveTrait";
let ShadowTraits = (_dec = primitiveTrait({
  type: "string",
  name: "Shadows",
  description: "Determines whether the tileset casts or receives shadows from each light source."
}), _dec2 = primitiveTrait({
  type: "boolean",
  name: "Show Shadow UI",
  description: "Determines whether the shadow UI component will be shown on the workbench item"
}), _class = class ShadowTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "shadows", _descriptor, this);
    _initializerDefineProperty(this, "showShadowUi", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "shadows", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "NONE";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showShadowUi", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _class);
export { ShadowTraits as default };